
export default function ProductsSection() {
  const products = [
    {
      id: 1,
      name: 'Sync 360',
      title: 'Sync360: The Future of Sports Training—Made Today for Tomorrow\'s Champions',
      description: 'Empowering and syncing coaches, athletes, parents, and academies in a unified, tech-driven training platform.',
      features: [
        'Powerful end-to-end coaching tools',
        'Real-time athlete progress tracking',
        'Engaged parent experience',
        'Total academy management in one place',
        'New revenue streams for every stakeholder',
        'Smart payments and scheduling'
      ],
      image: 'https://readdy.ai/api/search-image?query=Advanced%20sports%20performance%20analytics%20system%20with%20360%20degree%20motion%20capture%20technology%2C%20modern%20sleek%20interface%20showing%20athlete%20movement%20data%2C%20clean%20white%20background%2C%20professional%20sports%20technology%20equipment%2C%20high-tech%20sensors%20and%20cameras%2C%20futuristic%20design&width=600&height=400&seq=sync360&orientation=landscape',
      color: 'from-blue-600 to-cyan-500',
      iconColor: 'text-blue-500'
    },
    {
      id: 2,
      name: 'Rays Venue',
      title: 'Smart Sports Facility Management',
      description: 'Comprehensive venue management platform that streamlines facility operations, booking systems, and enhances the overall sports facility experience.',
      features: [
        'Smart Booking System',
        'Facility Resource Management',
        'Automated Scheduling',
        'Revenue Optimization',
        'Customer Experience Enhancement'
      ],
      image: 'https://readdy.ai/api/search-image?query=Modern%20sports%20facility%20management%20dashboard%20interface%2C%20smart%20venue%20control%20system%2C%20booking%20calendar%20and%20resource%20management%2C%20clean%20professional%20design%2C%20sports%20facility%20interior%20with%20digital%20displays%2C%20white%20background%2C%20technology%20integration&width=600&height=400&seq=raysvenue&orientation=landscape',
      color: 'from-green-600 to-emerald-5 00',
      iconColor: 'text-green-500'
    },
    {
      id: 3,
      name: 'Club7MS',
      title: 'Complete Club Management System',
      description: 'All-in-one club management solution designed for sports clubs, associations, and facilities to manage memberships, operations, and member engagement.',
      features: [
        'Membership Management',
        'Payment Processing',
        'Event Organization',
        'Communication Tools',
        'Performance Tracking'
      ],
      image: 'https://readdy.ai/api/search-image?query=Comprehensive%20sports%20club%20management%20system%20interface%2C%20membership%20dashboard%20with%20member%20profiles%2C%20payment%20processing%2C%20event%20calendar%2C%20communication%20tools%2C%20modern%20clean%20design%2C%20white%20background%2C%20professional%20sports%20management%20software&width=600&height=400&seq=club7ms&orientation=landscape',
      color: 'from-orange-600 to-red-500',
      iconColor: 'text-orange-500'
    }
  ];

  return (
    <section id="products" className="section-wrap bg-gray-900">
      <div className="page-container">
        <div className="text-center section-heading-gap">
          <p className="text-orange-500 text-lg font-medium mb-2">Our Products</p>
          <h2 className="section-title mb-6">
            Three Powerful Solutions for <span className="text-orange-500">Modern Sports</span>
          </h2>
          <p className="text-gray-300 text-xl max-w-3xl mx-auto">
            Discover our comprehensive suite of sports technology products designed to revolutionize 
            how athletes train, venues operate, and clubs manage their communities.
          </p>
        </div>

        <div className="space-y-20">
          {products.map((product, index) => (
            <div
              key={product.id}
              className={`grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-12 items-center ${
                index % 2 === 1 ? 'lg:grid-flow-col-dense' : ''
              }`}
            >
              {/* Product Content */}
              <div className={`space-y-8 ${index % 2 === 1 ? 'lg:col-start-2' : ''}`}>
                <div>
                  <div className="flex items-center mb-4">
                    <div className={`w-12 h-12 rounded-full bg-gradient-to-r ${product.color} flex items-center justify-center mr-4`}>
                      {product.id === 1 ? (
                        <img 
                          src="https://static.readdy.ai/image/339666f1cc2ed60abac278570d511bdf/8b40b3e4f93f016360b6626a3dfeca81.png" 
                          alt="Sync360 Logo" 
                          className="w-8 h-8 object-contain"
                        />
                      ) : product.id === 3 ? (
                        <img 
                          src="https://static.readdy.ai/image/339666f1cc2ed60abac278570d511bdf/85813c79518faa567af58ee37c0bd187.png" 
                          alt="Club7MS Logo" 
                          className="w-8 h-8 object-contain"
                        />
                      ) : (
                        <i className={`ri-settings-3-line text-white text-xl`}></i>
                      )}
                    </div>
                    <h3 className="text-2xl md:text-3xl font-bold text-white">
                      {product.name}
                    </h3>
                  </div>
                  <h4 className="text-xl md:text-2xl font-semibold text-gray-200 mb-4">
                    {product.title}
                  </h4>
                  <p className="text-gray-300 text-lg leading-relaxed">
                    {product.description}
                  </p>
                </div>

                {/* Features List */}
                <div className="space-y-3">
                  <h5 className="text-lg font-semibold text-white mb-4">Key Features:</h5>
                  {product.features.map((feature, featureIndex) => (
                    <div key={featureIndex} className="flex items-center">
                      <div className={`w-6 h-6 rounded-full bg-gradient-to-r ${product.color} flex items-center justify-center mr-3 flex-shrink-0`}>
                        <i className="ri-check-line text-white text-sm"></i>
                      </div>
                      <span className="text-gray-300">{feature}</span>
                    </div>
                  ))}
                </div>

                {/* CTA Button */}
                <div className="flex flex-wrap gap-4">
                  <button className={`group bg-gradient-to-r ${product.color} hover:shadow-lg text-white font-semibold px-8 py-4 rounded-full transition-all duration-300 transform hover:scale-105 whitespace-nowrap cursor-pointer`}>
                    <span className="relative z-10 flex items-center">
                      Learn More
                      <i className="ri-arrow-right-line ml-2"></i>
                    </span>
                  </button>
                  <button 
                    onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
                    className="group border-2 border-gray-600 hover:border-orange-500 text-white hover:text-orange-500 font-semibold px-8 py-4 rounded-full transition-all duration-300 whitespace-nowrap cursor-pointer"
                  >
                    <span className="relative z-10 flex items-center">
                      Send us a Message
                      <i className="ri-mail-line ml-2"></i>
                    </span>
                  </button>
                </div>
              </div>

              {/* Product Image */}
              <div className={`relative ${index % 2 === 1 ? 'lg:col-start-1' : ''}`}>
                <div className="relative overflow-hidden rounded-2xl shadow-2xl">
                  <img
                    src={product.image}
                    alt={`${product.name} - ${product.title}`}
                    className="w-full h-auto hover:scale-105 transition-transform duration-500 cursor-pointer object-top"
                  />
                  <div className={`absolute inset-0 bg-gradient-to-t from-black/30 to-transparent`}></div>
                </div>
                
                {/* Product Badge */}
                <div className={`absolute top-6 left-6 bg-gradient-to-r ${product.color} text-white px-4 py-2 rounded-full font-semibold text-sm`}>
                  {product.name}
                </div>

                {/* Floating Stats */}
                <div className="absolute bottom-6 right-6 bg-black/80 backdrop-blur-sm rounded-lg p-4">
                  <div className="text-center">
                    <div className={`${product.iconColor} font-bold text-2xl`}>#{product.id}</div>
                    <div className="text-white text-xs">Product Suite</div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="text-center mt-16">
          <div className="bg-gradient-to-r from-orange-600 to-red-600 rounded-2xl p-8 md:p-12">
            <h3 className="text-2xl md:text-3xl font-bold text-white mb-4">
              Ready to Transform Your Sports Experience?
            </h3>
            <p className="text-orange-100 text-lg mb-8 max-w-2xl mx-auto">
              Discover how our three powerful products can work together to create 
              a comprehensive sports technology ecosystem for your organization.
            </p>
            <button className="group bg-white hover:bg-gray-100 text-orange-600 font-semibold px-10 py-4 rounded-full transition-all duration-300 transform hover:scale-105 whitespace-nowrap cursor-pointer">
              <span className="relative z-10 flex items-center">
                Get Started Today
                <i className="ri-rocket-line ml-2"></i>
              </span>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
